import type { ExpressionSpecification } from "maplibre-gl";

export const CLUSTER_RADIUS: ExpressionSpecification = [
  "*",
  [
    "interpolate",
    ["linear"],
    ["get", "point_count"],
    1,
    16,
    100,
    28,
    500,
    40,
  ],
  ["case", ["boolean", ["feature-state", "hover"], false], 1.2, 1],
];

export const CLUSTER_COLOR: ExpressionSpecification = [
  "interpolate",
  ["linear"],
  ["get", "point_count"],
  1,
  "#0369a1",
  50,
  "#0ea5e9",
  200,
  "#fb923c",
  500,
  "#fbbf24",
];

export const PIN_RADIUS: ExpressionSpecification = [
  "interpolate",
  ["linear"],
  ["zoom"],
  2,
  ["*", 3, ["coalesce", ["get", "markerWeight"], 1]],
  4,
  ["*", 5, ["coalesce", ["get", "markerWeight"], 1]],
  6,
  ["*", 7, ["coalesce", ["get", "markerWeight"], 1]],
  8,
  ["*", 9, ["coalesce", ["get", "markerWeight"], 1]],
  10,
  ["*", 11, ["coalesce", ["get", "markerWeight"], 1]],
  12,
  ["*", 14, ["coalesce", ["get", "markerWeight"], 1]],
];

export const PIN_COLOR: ExpressionSpecification = [
  "case",
  ["!=", ["get", "geocodeStatus"], "precise"],
  "#f87171",
  ["boolean", ["get", "isDomestic"], true],
  "#34d399",
  "#38bdf8",
];

export const PIN_STROKE: ExpressionSpecification = [
  "case",
  ["!=", ["get", "geocodeStatus"], "precise"],
  "#7f1d1d",
  ["boolean", ["get", "isDomestic"], true],
  "#064e3b",
  "#1e3a8a",
];

export const HEATMAP_PAINT = {
  "heatmap-intensity": ["interpolate", ["linear"], ["zoom"], 0, 0.5, 9, 1.5],
  "heatmap-color": [
    "interpolate",
    ["linear"],
    ["heatmap-density"],
    0,
    "rgba(15, 23, 42, 0)",
    0.3,
    "#0ea5e9",
    0.6,
    "#fbbf24",
    1,
    "#f97316",
  ] as ExpressionSpecification,
  "heatmap-radius": ["interpolate", ["linear"], ["zoom"], 0, 6, 6, 25, 12, 60],
  "heatmap-opacity": ["interpolate", ["linear"], ["zoom"], 7, 0.8, 12, 0.1],
};
